<template>
  <name-field v-bind="$attrs" type="first" autocomplete-type="given" @changed="changed" @focus="$emit('focus')" />
</template>

<script>
import NameField from './name-field'

export default {
  components: { NameField },

  emits: ['changed', 'focus'],

  methods: {
    changed(newValue) {
      this.$emit('changed', newValue)
    }
  }
}
</script>
